import React, { useState, useEffect } from "react";
import Head from "next/head";
import { Link } from "@/components/Navigation";
import Layout from "layouts";
import Alert from "@/components/Alert";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import isWebview from "is-ua-webview";
import { Box, Button, Flex } from "@chakra-ui/react";
import { ButtonOutline, ButtonPrimary, ButtonSocmed } from "@/components/Form";
import { colors } from "@/styles/theme/constants";
import { Body, Text } from "@/components/Typography";
import { LandingPageProps } from "./types";
import Modal from "@/components/Modal";
import ModalHeader from "@/components/Modal/ModalHeader";
import Image from "next/image";

export default function LandingPage(props: LandingPageProps) {
  const {
    alertMessageSocmed,
    handleIdpSignIn,
    isOpenModal,
    onCloseModal,
    onOpenModal,
  } = props;

  const [isOpenOnWebview, setIsOpenOnWebview] = useState(false);

  const checIskWebview = () => {
    const userAgent = window.navigator.userAgent || "";
    const detectWebviewResult = isWebview(userAgent);

    setIsOpenOnWebview(detectWebviewResult);
  };

  useEffect(() => {
    checIskWebview();
  }, []);

  return (
    <Layout>
      <Box data-testid="container_landingPage">
        <Box mb="24px" data-testid="section_buttonCta_landingPage">
          <Link href="/register">
            <ButtonPrimary
              data-testid="buttonRegister_landingPage"
              width="100%"
              mb="8px"
            >
              Daftar
            </ButtonPrimary>
          </Link>
          <Link href="/login">
            <ButtonOutline data-testid="buttonLogin_landingPage" width="100%">
              Masuk
            </ButtonOutline>
          </Link>
        </Box>
        <Box>
          {/* hide login with socmed if user open login page from webview */}
          {!isOpenOnWebview && (
            <Box data-testid="section_socmed_landingPage">
              <Flex
                data-testid="separator_optionLoginSocmed_landingPage"
                position="relative"
                justifyContent="center"
                alignItems="center"
                mb="24px"
              >
                <Text
                  data-testid="separatorText_optionLoginSocmed_landingPage"
                  variant="othersStatus"
                  as="span"
                  position="relative"
                  backgroundColor="#F6F7F9"
                  color={colors.shade05}
                  zIndex="10"
                  padding="0 16px"
                >
                  ATAU
                </Text>
                <Box
                  as="span"
                  position="absolute"
                  border={`1px solid ${colors.shade06}`}
                  height="1px"
                  width="100%"
                  left="0"
                  top="50%"
                />
              </Flex>
              <Box data-testid="section_socmed_landingPage">
                {alertMessageSocmed && (
                  <Box mb="16px" data-testid="alert_socmed_landingPage">
                    <Alert text={alertMessageSocmed} />
                  </Box>
                )}
                <Flex
                  data-testid="grid_socmed_landingPage"
                  alignItems="center"
                  justifyContent="center"
                  gap="8px"
                >
                  <ButtonSocmed
                    data-testid="button_socmed_apple"
                    variant="apple"
                    onClick={() =>
                      handleIdpSignIn(CognitoHostedUIIdentityProvider.Apple)
                    }
                  />
                  <ButtonSocmed
                    data-testid="button_socmed_facebook"
                    variant="facebook"
                    onClick={() =>
                      handleIdpSignIn(CognitoHostedUIIdentityProvider.Facebook)
                    }
                  />
                  <ButtonSocmed
                    data-testid="button_socmed_google"
                    variant="google"
                    onClick={() =>
                      handleIdpSignIn(CognitoHostedUIIdentityProvider.Google)
                    }
                  />
                </Flex>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Modal
        onClose={onCloseModal}
        isOpen={isOpenModal}
        noMaxHeight={true}
        disabled={true}
        maxWidth={"327px"}
        hasCloseButton={false}
      >
        <ModalHeader showed={false} />
        <Flex alignItems={"center"} justifyContent={"center"} mx={"auto"}>
          <Image
            width={263}
            height={148}
            alt=""
            src="/assets/images/onboarding/account-already-banned.svg"
          />
        </Flex>
        <Body
          variant="Bold16"
          color="shade01"
          display={"flex"}
          alignItems={"center"}
          my={4}
        >
          Akunmu Telah Diblokir
        </Body>
        <Box
          data-testid="modal_successRegistration"
          className="mx-auto flex flex-col"
        >
          <Box mb={6}>
            <Body variant="Default14" color="shade03">
              Akun ini tidak dapat digunakan lagi karena melakukan pelanggaran:
            </Body>
            <Body
              variant="Default14"
              color="shade03"
              style={{ marginLeft: "1rem" }}
            >
              <li>Menyiarkan ulang konten IDN Live.</li>
              <li>Kirim komentar negatif berulang kali.</li>
              <li>Kirim gambar/chat berisi SARA.</li>
            </Body>
            <Body variant="Default14" color="shade03">
              Silakan baca penjelasan lengkapnya di bawah ini.
            </Body>
          </Box>
          <Link
            href="/my-account/user-guide#account-banned"
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: "100%" }}
          >
            <ButtonPrimary
              data-testid="buttonRedirect_PrivacyPolicy"
              width="100%"
              mb="8px"
            >
              Lihat Selengkapnya
            </ButtonPrimary>
          </Link>
          <ButtonOutline
            data-testid="buttonClose_accountBanned"
            width="100%"
            onClick={onCloseModal}
          >
            Tutup
          </ButtonOutline>
        </Box>
      </Modal>
    </Layout>
  );
}
